import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { ApprovalButton } from "../style/button";
import { BoxSpaceCenter } from '../style/box'
import { postData } from "../func/api";
import { useAuth } from "../contexts/AuthContext"; 

import { BaseDialog } from "./base_dialog";

export default function ReportApprovalDialog({ report_or_inspection_uuid, earthquake_uuid, setTaskStatus, type, report_uuid }) {
    const [open, setOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const handleClickOpen = () => {
      setOpen(true);
      setErrorMessage("");
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSendApproval = async () => {
        try {
            const payload = {
              earthquake_uuid: earthquake_uuid,
              report_or_inspection_uuid: report_or_inspection_uuid,
              note: "",
              status: true,
              user_uuid: currentUser.id,
              report_uuid: report_uuid
            };
            // 第一報
            if (type === "initial") {
                await postData("api/post_first_approval", payload);
                window.location.href = `/first_report/${earthquake_uuid}`;
                // 1次点検
            } else if (type === "primary") {
                await postData("api/post_primary_approval", payload);
                window.location.href = `/primary_inspection/${earthquake_uuid}`;
                // 2次点検
            } else {
                await postData("api/post_secondary_approval", payload);
                window.location.href = `/secondary_inspection/${earthquake_uuid}`;
            }
        } catch (error) {
            console.error("承認に失敗しました:", error);
            setErrorMessage("承認に失敗しました。もう一度お試しください。");
        }
        setOpen(false);
    };

  return (
    <>
        <BoxSpaceCenter>
            <ApprovalButton startIcon={<CheckCircleIcon/>} onClick={handleClickOpen}>
                承認
            </ApprovalButton>
            <BaseDialog
                open={open}
                onClose={handleClose}
                title="承認"
                message={"報告書の記載内容について承認を行います。\nよろしいですか？"}
                onConfirm={handleSendApproval}
                confirmText='OK'
                cancelText='キャンセル'
            />
        </BoxSpaceCenter>
    </>
  );
}
